import { jsonApiDeserialize } from "utils";

export default jsonApiDeserialize;
